<template>
  <div class="contenedor">
    <div id="formContent">
      <h2 class="titulo">Registrar Negocio</h2>
      <!--Nombre del comercio-->
      <input
        type="text"
        id="comercioName"
        autocomplete="off"
        class="input-solicitud-comercio"
        name="comercioName"
        placeholder="Nombre del Comercio"
        maxlength="30"
        v-model="comercio.name"
      />
      <!--Logo del comercio-->
      <file-pond
        name="test"
        ref="pond"
        class="logo-pond"
        className="logo-pond-root"
        accepted-file-types="image/jpeg, image/png, image/webp"
        server="/api"
        max-files="1"
        instant-upload="false"
        allowProcess="false"
        credits=""
        label-idle="Logo del comercio: Arrastralo o haz click aquí"
        labelFileLoading="Cargando"
        labelFileLoadError="Error al cargar"
        labelFileProcessing="Subiendo"
        labelFileProcessingError="Error al subir el logo"
        labelTapToCancel="Presiona para cancelar"
        labelMaxFileSizeExceeded="El logo es muy pesado"
        labelMaxFileSize="El tamaño máximo es {filesize}"
        :maxFileSize="PesoMaximoLogo"
        v-bind:files="logosSubidos"
        v-on:addfile="logoAgregado"
        v-on:removefile="logoEliminado"
      />
      <!--Dirección-->
      <input
        type="text"
        id="address"
        class="input-solicitud-comercio"
        name="address"
        placeholder="Dirección"
        maxlength="40"
        v-model="comercio.address"
      />
      <!--Teléfono-->
      <input
        type="tel"
        id="phone"
        required
        class="input-solicitud-comercio"
        name="phone"
        placeholder="Teléfono"
        maxlength="40"
        v-model="comercio.phone"
      />
      <!--CUIT-->
      <input
        type="text"
        id="cuit"
        class="input-solicitud-comercio"
        name="cuit"
        placeholder="CUIT"
        maxlength="30"
        v-model="comercio.cuit"
      />
      <!--Correo electrónico-->
      <input
        type="email"
        id="email"
        class="input-solicitud-comercio"
        required
        name="email"
        placeholder="Correo electrónico"
        maxlength="40"
        v-model="comercio.email"
      />
      <!--Provincia-->
      <select class="custom-select" @change="provinciaCambiada($event)">
        <option selected>Provincia</option>
        <option
          v-for="prov in provincias"
          v-bind:key="prov.id"
          v-bind:value="prov.id"
        >
          {{ prov.nombre }}
        </option>
      </select>
      <!--Localidad, no funciona agregarle clases css, por eso se usa "style"-->
      <list-select
        @select="localidadElegida"
        :list="localidades"
        optionValue="id"
        optionText="nombre"
        placeholder="Localidad"
        :selectedItem="localidadActual"
        style="
          display: inline-block;
          width: 85%;
          padding: 15px 32px;
          margin: 5px;
          font-size: 16px;
          border: 2px solid #f6f6f6;
          border-radius: 5px 5px 5px 5px;
          transition: all 0.5s ease-in-out;
          background-color: #f6f6f6;
          color: #0d0d0d;
        "
      />

      <!--Beneficio-->
      <h2 class="titulo">Registrar Beneficio</h2>

      <!--Nombre del beneficio-->
      <input
        type="text"
        id="beneficioName"
        autocomplete="off"
        class="input-solicitud-comercio"
        name="beneficioName"
        placeholder="Nombre del Beneficio"
        maxlength="40"
        v-model="beneficio.name"
      />
      <!-- Porcentaje de descuento -->
      <input-info
        id="porcentajeDescuento"
        info="Porcentaje de descuento sin el %. Ejemplo: 20"
        type="number"
        autocomplete="off"
        input-class="input-solicitud-comercio"
        info-class="info-bajo-input registrar-negocio"
        name="porcentajeDescuento"
        placeholder="Porcentaje de descuento"
        maxlength="40"
        v-model="beneficio.discountPercentage"
      />

      <!--Categoria-->
      <select class="custom-select" @change="seleccionarCategoria($event)">
        <option selected v-bind:value="null">Categoría</option>
        <option
          v-for="cat in categorias"
          v-bind:key="cat.id"
          v-bind:value="cat.id"
        >
          {{ cat.name }}
        </option>
      </select>

      <!-- Subcategorias -->
      <select class="custom-select" @change="seleccionarSubCategoria($event)">
        <option selected v-bind:value="null">Sub Categoría</option>
        <option
          v-for="sub in subcategorias"
          v-bind:key="sub.id"
          v-bind:value="sub.id"
        >
          {{ sub.name }}
        </option>
      </select>

      <!--Permite invitado-->
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          value=""
          id="allowsVisita"
          v-model="beneficio.allowsVisita"
        />
        <label class="form-check-label cursor-pointer" for="allowsVisita">
          Permitir usuarios sin registro
        </label>
        <button
          @click="infoAllowsVisita = !infoAllowsVisita"
          class="boton-info ml-3"
        >
          <font-awesome-icon :icon="Icons.INFO" />
        </button>
      </div>
      <p v-if="infoAllowsVisita" class="info-bajo-input registrar-negocio">
        Permitir que usuarios invitados (sin registrarse) puedan ver el
        beneficio.
      </p>

      <!--Días habilitados-->
      <week-day-picker
        v-model="beneficio.diaHabilitadoList"
        class="input-solicitud-comercio"
      >
        <template slot="label">Días habilitados</template>
      </week-day-picker>

      <!--Medio de pago-->
      <input
        type="text"
        class="input-solicitud-comercio"
        placeholder="Medio de pago"
        aria-label="Ingrese aquí"
        aria-describedby="basic-addon1"
        maxlength="40"
        v-model="beneficio.payMethod"
      />

      <!--Comentarios-->
      <h2 class="titulo">Comentarios</h2>
      <input-info
        type="text"
        id="observations"
        name="observations"
        autocomplete="off"
        placeholder="Comentarios"
        maxlength="300"
        v-model="comercio.observations"
        info="Comentarios que serán revisados al procesar la solicitud"
        input-class="input-solicitud-comercio"
        info-class="info-bajo-input registrar-negocio"
      />

      <!--Enviar solicitud-->
      <div class="mt-4 mb-3">
        <button
          @click="enviar"
          id="boton-enviar"
          :disabled="!!DatosFaltantes || enviando"
          class="btn btn-success"
        >
          <span
            v-if="enviando"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          >
          </span>
          <span v-if="enviando"> Enviando...</span>
          <span v-if="!enviando">Enviar solicitud</span>
        </button>
        <p v-if="!!DatosFaltantes" class="info-bajo-input registrar-negocio">
          <i>Falta {{ DatosFaltantes }}</i>
        </p>
      </div>
      <!--Footer-->
      <div id="formFooter">
        <div class="div-home">
          <a class="link-home" @click="irAHome()">
            <span>Volver al Home</span>
            <font-awesome-icon :icon="Icons.INICIO" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ListSelect } from "vue-search-select";
import Swal from "sweetalert2";

import { Api } from "../../api";
import { environment } from "../../environments/environment";

import InputInfo from "../../components/util/InputInfo";
import { Icons as IconConstants } from "../../constants";
import { Util } from "../../util";

//#region  Filepond
// Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import WeekDayPicker from "../../components/util/WeekDayPicker.vue";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize
);
//#endregion

export default {
  components: {
    FontAwesomeIcon,
    ListSelect,
    FilePond,
    InputInfo,
    WeekDayPicker
  },
  data() {
    return {
      beneficio: {
        allowsVisita: false,
        diaHabilitadoList: [],
        discountPercentage: undefined,
        name: null,
        payMethod: undefined,
        subcategoriaId: null
      },
      comercio: {
        address: null,
        cuit: null,
        email: null,
        localidadId: null,
        name: null,
        observations: null,
        phone: null
      },
      /**Verdadero cuando se está enviando la solicitud */
      enviando: false,
      idCategoria: null,
      /**Muestra información extra en allowsVisita */
      infoAllowsVisita: false,
      logo: null,
      /**Utilizado para limpiar filepond cuando se necesite */
      logosSubidos: [],
      provincias: [],
      /**Utilizado para mostrar el nombre de la localidad */
      localidadActual: {
        id: null,
        nombre: null
      },
      localidades: [],
      categorias: [],
      subcategorias: []
    };
  },
  computed: {
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    /**Devuelve una cadena con los datos que faltan */
    DatosFaltantes() {
      let cadena = "";

      if (!this.comercio.name) {
        cadena = Util.agregarACadenaConComa(cadena, "nombre de comercio");
      }

      if (!this.logo) {
        cadena = Util.agregarACadenaConComa(cadena, "logo");
      }

      if (!this.comercio.phone) {
        cadena = Util.agregarACadenaConComa(cadena, "teléfono");
      }

      if (!this.comercio.email) {
        cadena = Util.agregarACadenaConComa(cadena, "correo electrónico");
      }

      if (!this.comercio.localidadId) {
        cadena = Util.agregarACadenaConComa(cadena, "localidad");
      }

      if (!this.beneficio.name) {
        cadena = Util.agregarACadenaConComa(cadena, "nombre de beneficio");
      }

      if (!this.beneficio.discountPercentage) {
        cadena = Util.agregarACadenaConComa(cadena, "porcentaje de descuento");
      }

      if (!this.beneficio.subcategoriaId) {
        cadena = Util.agregarACadenaConComa(cadena, "subcategoría");
      }

      return cadena;
    },
    PesoMaximoLogo() {
      return environment.LOGO_PESO_MAXIMO;
    }
  },
  methods: {
    //#region filepond
    logoAgregado(error, logo) {
      if (!error) {
        this.logo = logo.file;
      } else {
        this.logo = null;
      }
    },
    logoEliminado() {
      this.logo = null;
    },
    //#endregion
    provinciaCambiada: async function(event) {
      this.idProvincia = event.target.value;
      this.localidadElegida(null);

      if (this.idProvincia !== "") {
        Api.Localidad.getLocalidadesDeProvincia(this.idProvincia).then(
          response => {
            this.localidades = response.data;
          }
        );
      }
    },
    localidadElegida(loc) {
      this.localidadActual = loc;
      this.comercio.localidadId = loc ? loc.id : null;
    },
    seleccionarCategoria: async function(event) {
      this.idCategoria = event.target.value;
      this.beneficio.subcategoriaId = null;

      if (!this.idCategoria) {
        this.subcategorias = [];
      } else {
        Api.Categoria.getSubcategoriasDeCategoria(this.idCategoria).then(
          response => {
            this.subcategorias = response.data;
          }
        );
      }
    },
    seleccionarSubCategoria: async function(event) {
      const subcategoriaId = event.target.value;

      // Esto se asigna pero no en el momento, debe ser porque es asincrono
      this.beneficio.subcategoriaId = subcategoriaId;
    },
    enviar(e) {
      this.enviando = true;

      Api.Solicitud.enviar({
        comercio: this.comercio,
        beneficio: this.beneficio
      })
        .then(response => {
          if (this.logo) {
            // Subir logo
            this.subirLogo(response.data.comercioId)
              .then(() => {
                this.operacionExitosa();
              })
              .catch(() => {
                console.log("Error al subir logo");
                this.operacionErronea();
              })
              .finally(() => {
                this.enviando = false;
              });
          } else {
            this.operacionExitosa();
            this.enviando = false;
          }
        })
        .catch(() => {
          this.operacionErronea();
          this.enviando = false;
        });
      e.preventDefault();
    },
    subirLogo(comercioId) {
      let formData = new FormData();
      formData.append("image", this.logo);
      return Api.Logos.subir(comercioId, formData, this.token);
    },
    operacionExitosa() {
      Swal.fire({
        icon: "success",
        title: "Enviada",
        text: "Solicitud enviada. Pronto nos contactaremos con usted."
      });

      this.irAHome();
    },
    operacionErronea() {
      Swal.fire({
        icon: "error",
        title: "Problemas",
        text:
          "Ocurrió un problema al enviar la solicitud. Intente de nuevo más tarde."
      });
    },
    irAHome() {
      this.$router.push("/");
    }
  },
  mounted() {
    // Cargar provincias
    Api.Localidad.getProvincias().then(response => {
      this.provincias = response.data;
    });

    // Cargar categorías
    Api.Categoria.getTodas().then(response => {
      this.categorias = response.data;
    });
  }
};
</script>

<style>
/* global styles */
.input-solicitud-comercio {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

.input-solicitud-comercio:focus {
  background-color: #fff;
  border-bottom: 2px solid #42b983;
  outline: none;
}
.input-solicitud-comercio:placeholder {
  color: #cccccc;
}
.info-bajo-input.registrar-negocio {
  max-width: 90%;
  color: white;
}
</style>

<style scoped>
/**Local styles */
*:focus {
  outline: none;
}
select {
  height: auto;
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

select:focus {
  background-color: #fff;
  border-bottom: 2px solid #42b983;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
}
.contenedor {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
  background-color: var(--color-moda-h);
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: var(--color-estructura-a);
  padding: 30px;
  min-width: 355px;
  width: 90%;
  max-width: 750px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

.titulo {
  color: var(--color-estructura-c);
}

.form-check {
  width: 80%;
  margin: auto;
  color: white;
  height: 40px;
  padding-top: 8px;
  align-items: center;
}

.logo-pond {
  display: inline-block;
  width: 85%;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

input[type="button"],
#boton-enviar {
  background-color: #42b983;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 3px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type="button"]:hover,
#boton-enviar:hover {
  background-color: #64d8a4;
}

input[type="button"]:active,
boton-enviar:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

#boton-enviar:disabled {
  background-color: #c2c3c3;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.div-home {
  align-self: flex-start;
}

.div-home a {
  color: var(--color-estructura-a);
  text-decoration: none;
}

.div-home a:hover,
.div-home svg:hover {
  color: var(--color-estructura-c);
  font-size: 13px;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.div-home svg {
  margin-left: 10px;
}

.link-home {
  cursor: pointer;
}
</style>
